"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.confirmAgendaSlotReservationApiResponseSchema = void 0;
const zod_1 = require("zod");
const agenda_slot_reservation_1 = require("../agenda-slots/agenda-slot-reservation");
exports.confirmAgendaSlotReservationApiResponseSchema = zod_1.z.object({
    data: agenda_slot_reservation_1.agendaSlotReservationApiSchema,
    included: zod_1.z
        .array(agenda_slot_reservation_1.slotReservationDoctorSubstituteSchema)
        .optional()
        .default([]),
    meta: zod_1.z
        .object({
        autoDeclinedIds: zod_1.z.array(zod_1.z.string()).default([]),
    })
        .optional(),
});
